import PageWrapper from "../../../../components/PageWrapper";
import { CandidateJobListPage } from "../../../../modules/self-apply/job-list/candidate";

const SelfApplyJobsListPage = () => {
  return (
    <PageWrapper title="Careers">
      <CandidateJobListPage />
    </PageWrapper>
  );
};

export default SelfApplyJobsListPage;
